import(/* webpackMode: "eager" */ "/app/node_modules/aelf-design/dist/esm/styles/fonts.css");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/app/src/app/GtagConfigScript.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/layout-content.tsx");
import(/* webpackMode: "eager" */ "/app/src/app/VconsoleScript.tsx");
import(/* webpackMode: "eager" */ "/app/src/provider/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/styles/global.css");
import(/* webpackMode: "eager" */ "/app/src/styles/theme.css");
import(/* webpackMode: "eager" */ "/app/src/styles/button.css");
import(/* webpackMode: "eager" */ "/app/src/assets/fonts/tmrwdao-icon.css")